import { render, staticRenderFns } from "./EmailAuthBind.vue?vue&type=template&id=6dc19195&scoped=true&"
import script from "./EmailAuthBind.vue?vue&type=script&lang=js&"
export * from "./EmailAuthBind.vue?vue&type=script&lang=js&"
import style0 from "./EmailAuthBind.vue?vue&type=style&index=0&id=6dc19195&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc19195",
  null
  
)

export default component.exports